"use strict";

angular.module("customer")
.controller("ExternalLoginController", function(
    $stateParams, $scope, $http, $location, UserService, FlashBag, ValidateBrowserCookieSupportService, appConfig
) {
    var payload = $stateParams.payload;

    ValidateBrowserCookieSupportService.validate().then(
        function onSuccess() {
            $http.post(appConfig.API_SERVER + "/punch-out/login", {
                "payload": payload
            }).then(
                function onSuccess(response) {
                    UserService.persistAuthToken(response, true);
                    $location.path(response.data.next_location);
                },
                function onError(response) {
                    if (response.data.expiration) {
                        $scope.loginExpired = true;
                    }
                    else {
                        FlashBag.apiError(response);
                    }
                }
            )
        },
        function onError() {
            $scope.cookiesNotSupported = true;
        }
    );
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/auth/external-login.controller.js
// module id = 951
// module chunks = 0